var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-navbar',{staticClass:"is-dark top-navbar"},[_c('template',{slot:"brand"},[_c('b-navbar-item',[_c('p',[_vm._v("CoViD Italia")])])],1),_c('template',{slot:"start"},[_c('b-navbar-item',{attrs:{"href":"#"}},[_vm._v("Hella")])],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }